import type { AccessContext } from './landingPage';
import {
  hasNormalDashboardAccess,
  hasSgDashboardAccess,
  OPERATIONAL_DASHBOARD_PATH,
  SG_DASHBOARD_PATH,
} from './dashboardAccess';
import type { NavItemDef } from './navConfig';
import { canAccess } from './permissionUtils';
import { ROUTE_ACCESS } from './routes';

/** Sidebar dashboard links — each entry is shown when the user has the matching permission. */
export function getDashboardNavItems(ctx: AccessContext): NavItemDef[] {
  const items: NavItemDef[] = [];
  if (hasSgDashboardAccess(ctx.permissions)) {
    items.push({ to: SG_DASHBOARD_PATH, labelKey: 'nav.sgDashboard' });
  }
  if (hasNormalDashboardAccess(ctx.permissions)) {
    items.push({ to: OPERATIONAL_DASHBOARD_PATH, labelKey: 'nav.operationalDashboard' });
  }
  return items;
}

/** Whether a sidebar route should be shown for the current user. */
export function isNavRouteVisible(to: string, ctx: AccessContext): boolean {
  if (!canAccess(ROUTE_ACCESS[to], ctx)) return false;
  return true;
}
